var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.5,
    r: 13,
    fill: "#131313"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2398 12.0669C18.0129 12.0696 16.8163 11.6866 15.8189 10.9722V15.953C15.8186 16.8755 15.5367 17.7759 15.0108 18.5338C14.4849 19.2917 13.7402 19.871 12.8762 20.1941C12.0121 20.5173 11.07 20.569 10.1759 20.3422C9.2817 20.1154 8.47808 19.621 7.87249 18.9252C7.2669 18.2293 6.88821 17.3651 6.78708 16.4482C6.68594 15.5313 6.86717 14.6054 7.30653 13.7942C7.7459 12.9831 8.42245 12.3255 9.2457 11.9093C10.069 11.4931 10.9997 11.3381 11.9133 11.4652V13.9696C11.4956 13.8381 11.0469 13.8419 10.6314 13.9806C10.216 14.1192 9.85493 14.3856 9.59988 14.7417C9.34483 15.0978 9.20881 15.5253 9.21123 15.9633C9.21365 16.4013 9.35439 16.8273 9.61337 17.1806C9.87234 17.5338 10.2363 17.7962 10.6533 17.9302C11.0702 18.0643 11.5189 18.0632 11.9352 17.9271C12.3515 17.7909 12.7142 17.5267 12.9714 17.1722C13.2286 16.8177 13.3672 16.391 13.3675 15.953V6.21973H15.8189C15.8175 6.42706 15.8352 6.63407 15.8718 6.83815C15.9571 7.29306 16.1342 7.72581 16.3924 8.10994C16.6505 8.49408 16.9843 8.82153 17.3733 9.0723C17.9271 9.43802 18.5762 9.63274 19.2398 9.63223V12.0669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.7035b2d579649815579a7b268e5b11d7.svg";
export { ForwardRef as ReactComponent };